import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, CardBody } from "reactstrap";

const TermsAndConditions = () => {
  //meta title
  document.title = "Terms and Conditions | BizServe";

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg="10">
              <Card>
                <CardBody className="p-4">
                  <div className="text-center mb-4">
                    <h2 className="mb-3">Terms and Conditions</h2>
                    <p className="text-muted">Last Updated: {new Date().toLocaleDateString()}</p>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">1. Acceptance of Terms</h4>
                    <p className="text-muted">
                      By accessing and using BizServe's services, you accept and agree to be bound by the terms and provision 
                      of this agreement. If you do not agree to abide by the above, please do not use this service.
                    </p>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">2. Use License</h4>
                    <p className="text-muted mb-2">
                      Permission is granted to temporarily use BizServe's services for personal and commercial purposes. This 
                      is the grant of a license, not a transfer of title, and under this license you may not:
                    </p>
                    <ul className="text-muted">
                      <li>Modify or copy the materials</li>
                      <li>Use the materials for any commercial purpose or for any public display</li>
                      <li>Attempt to reverse engineer any software contained on BizServe's website</li>
                      <li>Remove any copyright or other proprietary notations from the materials</li>
                    </ul>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">3. User Accounts</h4>
                    <p className="text-muted mb-2">When you create an account with us, you must provide information that is:</p>
                    <ul className="text-muted">
                      <li>Accurate, complete, and current</li>
                      <li>Not misleading or fraudulent</li>
                      <li>In compliance with all applicable laws and regulations</li>
                    </ul>
                    <p className="text-muted mt-2">
                      You are responsible for safeguarding the password and for all activities that occur under your account.
                    </p>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">4. Service Availability</h4>
                    <p className="text-muted">
                      We strive to provide continuous access to our services, but we do not guarantee that the services will 
                      be available at all times. We reserve the right to modify, suspend, or discontinue any part of our 
                      services at any time without prior notice.
                    </p>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">5. Payment Terms</h4>
                    <p className="text-muted mb-2">
                      If you purchase a subscription or make a payment through our services:
                    </p>
                    <ul className="text-muted">
                      <li>All fees are non-refundable unless otherwise stated</li>
                      <li>You agree to provide current, complete, and accurate purchase and account information</li>
                      <li>You agree to promptly update your account and payment information</li>
                      <li>We reserve the right to change our pricing at any time</li>
                    </ul>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">6. User Content</h4>
                    <p className="text-muted">
                      You retain ownership of any content you submit, post, or display on or through our services. By submitting 
                      content, you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, and distribute 
                      your content in connection with operating and providing our services.
                    </p>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">7. Prohibited Uses</h4>
                    <p className="text-muted mb-2">You may not use our services:</p>
                    <ul className="text-muted">
                      <li>In any way that violates any applicable law or regulation</li>
                      <li>To transmit any malicious code, viruses, or harmful data</li>
                      <li>To impersonate or attempt to impersonate another user or entity</li>
                      <li>To engage in any automated use of the system</li>
                      <li>To interfere with or disrupt the services or servers</li>
                    </ul>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">8. Intellectual Property</h4>
                    <p className="text-muted">
                      The service and its original content, features, and functionality are and will remain the exclusive property 
                      of BizServe and its licensors. The service is protected by copyright, trademark, and other laws.
                    </p>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">9. Disclaimer</h4>
                    <p className="text-muted">
                      The information on this website is provided on an "as is" basis. To the fullest extent permitted by law, 
                      BizServe excludes all representations, warranties, and conditions relating to our website and the use of 
                      this website.
                    </p>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">10. Limitation of Liability</h4>
                    <p className="text-muted">
                      In no event shall BizServe, nor its directors, employees, partners, agents, suppliers, or affiliates, 
                      be liable for any indirect, incidental, special, consequential, or punitive damages, including without 
                      limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use 
                      of the service.
                    </p>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">11. Indemnification</h4>
                    <p className="text-muted">
                      You agree to defend, indemnify, and hold harmless BizServe and its licensee and licensors, and their employees, 
                      contractors, agents, officers and directors, from and against any and all claims, damages, obligations, losses, 
                      liabilities, costs or debt, and expenses (including but not limited to attorney's fees).
                    </p>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">12. Termination</h4>
                    <p className="text-muted">
                      We may terminate or suspend your account and bar access to the service immediately, without prior notice or 
                      liability, under our sole discretion, for any reason whatsoever and without limitation, including but not 
                      limited to a breach of the Terms.
                    </p>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">13. Governing Law</h4>
                    <p className="text-muted">
                      These Terms shall be interpreted and governed by the laws of the jurisdiction in which BizServe operates, 
                      without regard to its conflict of law provisions.
                    </p>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">14. Changes to Terms</h4>
                    <p className="text-muted">
                      We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision 
                      is material, we will provide at least 30 days notice prior to any new terms taking effect.
                    </p>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">15. Contact Information</h4>
                    <p className="text-muted">
                      If you have any questions about these Terms and Conditions, please contact us at:
                    </p>
                    <p className="text-muted">
                      <strong>Email:</strong> legal@bizserve.com<br />
                      <strong>Address:</strong> BizServe LLC, 123 Business Street, Suite 100, City, State, ZIP Code
                    </p>
                  </div>

                  <div className="mt-5 text-center">
                    <Link
                      className="btn btn-primary waves-effect waves-light"
                      to="/register"
                    >
                      Back to Registration
                    </Link>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TermsAndConditions;
